import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import ActualizacionDeDatos from "../components/ActualizacionDeDatos";
import Confirmacion from "../components/Confirmacion";
import ConfirmacionPendiente from "../components/ConfirmacionPendiente";
import Horario from "../components/Horario";
import PagoResumen from "../components/Pagos/Pago";
import PagoPensiones from "../components/Pagos/PagoPensiones";
import ProcesoMatricula from "../components/ProcesoMatricula";
import ReglamentosDeEstudios from "../components/ReglamentosDeEstudios";
import Seguro from "../components/Seguro";
import SeleccionHorario from "../components/SeleccionHorario";

import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";

import { apiListaSeguroAccidentes } from "../config/constantes";
import { formatterDate } from "../utils/FormatterDate";
import ModalError from "../components/ModalError";

import { sesionesHabilitadas } from "../services/procesoMatricula/procesoMatricula";

const Matricula = () => {
  const {
    obtenerDatosEstudiante,
    listadoRequisitosMatricula,
    gruposHabilitados,
  } = useMatricula();

  const {
    setObtenerSegurosAccidentesEstudiante,
    pasoProcesoM,
    setPasoProcesoM,
    pasoSegundaVistaProcesoM,
    listadoAsignaturasEstudiante,
    setListAsignaturasAgregadas,
    setLoading,
    setPasoSegundaVistaProcesoM,
    setResumenPagoEstudiante,
    setCuotaSeleccionada,
    setCarritoHorario,
  } = useProcesoMatricula();

  // =========================================================
  // PARAMETRO autoStart
  // =========================================================
  const [searchParams] = useSearchParams();
  const autoStart = searchParams.get("autoStart");

  const [ckeckValidator, setCkeckValidator] = useState(false);
  const [chequeoListo, setChequeoListo] = useState(false);

  const navigate = useNavigate();

  const {
    cinstitucion,
    cprograma,
    cperiodo,
    cpersona,
    finiciomatricula,
    ffinmatricula,
    pasomatricula,
    fsistema,
    dciclo,
    pasopago,
  } = obtenerDatosEstudiante || {};

  // =========================================================
  // FECHAS
  // =========================================================
  let fechaActual = new Date(`${fsistema}`);
  let fechaInicio = new Date(`${finiciomatricula}`);
  let fechaFin = new Date(`${ffinmatricula}`);

  // =========================================================
  // TOKEN
  // =========================================================
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  // =========================================================
  // INICIALIZAR PASO DE MATRÍCULA
  // =========================================================
  useEffect(() => {
    if (!obtenerDatosEstudiante) return;

    let pFinal = pasomatricula;

    /*
     * Si venimos desde PagoFinish:
     *
     * /matricula?autoStart=true
     *
     * Queremos mostrar el PASO 3 (Seguro).
     *
     * Tu función validateUseProcesoMatri funciona así:
     *
     * pasoProcesoM = 0 -> paso 1
     * pasoProcesoM = 1 -> paso 2
     * pasoProcesoM = 2 -> paso 3
     * pasoProcesoM = 3 -> paso 4
     *
     * Por eso aquí ponemos 2.
     */
    if (autoStart === "true") {
      pFinal = 2;
    }

    setPasoProcesoM(pFinal);

    const pasPago = pasopago == 1 ? false : true;

    setPasoSegundaVistaProcesoM(pasPago);

    setResumenPagoEstudiante({});
    setCuotaSeleccionada("");
  }, [
    obtenerDatosEstudiante,
    autoStart,
    pasomatricula,
    pasopago,
  ]);

  // =========================================================
  // VALIDAR PASO ACTUAL
  // =========================================================
  let validateUseProcesoMatri = (pag) => {
    const arrayPasos = [1, 2, 3, 4, 5, 6];

    let resultado = false;

    if (arrayPasos.slice(0, pasoProcesoM).length == 0) {
      if (pasoProcesoM + 1 == pag) {
        resultado = true;
      }
    } else {
      if (pasoProcesoM + 1 == pag) {
        resultado = true;
      }
    }

    return resultado;
  };

  // =========================================================
  // VALIDAR API
  // =========================================================
  const prometeValidarApi = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config).then((data) => {
        if (data.status == 200) {
          resolver(data);
        } else {
          rechazar(new Error(data));
        }
      });
    });
  };

  // =========================================================
  // VALIDAR REQUISITOS
  // =========================================================
  useEffect(() => {
    if (!listadoRequisitosMatricula) return;

    let validarCkeck = listadoRequisitosMatricula.filter((dat) => {
      return [dat.bcompletado].indexOf(false) !== -1;
    });

    validarCkeck.length !== 0
      ? setCkeckValidator(false)
      : setCkeckValidator(true);

    if (
      listadoRequisitosMatricula &&
      listadoRequisitosMatricula.length > 0 &&
      obtenerDatosEstudiante &&
      obtenerDatosEstudiante.fsistema
    ) {
      setChequeoListo(true);
    }
  }, [
    listadoRequisitosMatricula,
    obtenerDatosEstudiante,
  ]);

  // =========================================================
  // LISTADO DE SEGUROS
  // =========================================================
  useEffect(() => {
    if (cinstitucion) {
      let listado_seguros = async () => {
        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              `Bearer ` + tokenGlos.access_token,
          },
          body: JSON.stringify({
            p_cpersona: cpersona,
            p_cinstitucion: cinstitucion,
            p_cprograma: cprograma,
            p_cperiodo: cperiodo,
          }),
        };

        try {
          const lstSeguroAccidentes =
            await prometeValidarApi(
              `${apiListaSeguroAccidentes}`,
              config
            );

          const lstSeguroAccidentesJson =
            await lstSeguroAccidentes.json();

          const { Data } = lstSeguroAccidentesJson;

          setObtenerSegurosAccidentesEstudiante(Data);

          const { ntipo } = Data || {};

          if (ntipo) {
            setCarritoHorario({
              ntipos: Data.ntipo,
            });
          }
        } catch (error) {
          console.error(
            "Error obteniendo seguros:",
            error
          );
        }
      };

      listado_seguros();
    }
  }, [obtenerDatosEstudiante]);

  // =========================================================
  // ASIGNATURAS
  // =========================================================
  useEffect(() => {
    if (dciclo !== "I") {
      let buscarAsignaturas =
        listadoAsignaturasEstudiante.map(
          (asignatura) => {
            let filtro;

            gruposHabilitados.filter((data) => {
              if (
                data.ccurso == asignatura.ccurso &&
                data.cgrupo == asignatura.cgrupo
              ) {
                let inicio = formatterDate(
                  data.finicio
                );

                let fin = formatterDate(
                  data.ffin
                );

                const newRow = {
                  scurso: asignatura.scurso,
                  sgrupo: asignatura.sgrupo,
                  dcurso: asignatura.dcurso,
                  gtipo: asignatura.gtipo,
                  ncreditos: asignatura.ncreditos,
                  nhoras: asignatura.nhoras,
                  dhorario: data.dhorario,
                  finicio: inicio,
                  ffin: fin,
                  ddocente: data.ddocente,
                  cciclo: data.cciclo,
                  dsumilla: data.dsumilla,
                  nveces: data.nveces,
                  ccarrera: data.ccarrera,
                  casignatura: data.casignatura,
                  cgrupo: asignatura.cgrupo,
                  ctipo: asignatura.ctipo,
                  ccurso: asignatura.ccurso,
                  dequivalente:
                    asignatura.dequivalente,
                  sequivalente:
                    asignatura.sequivalente,
                  ccurso_origen:
                    data.ccurso_origen,
                  ccurso_equivalente:
                    data.ccurso_equivalente,
                  dmodalidad:
                    asignatura.dmodalidad,
                  gmodalidad:
                    asignatura.gmodalidad,
                };

                filtro = newRow;
              }
            });

            return filtro;
          }
        );

      let lmpiarUndefined =
        buscarAsignaturas.filter(
          (e) => e != undefined
        );

      setListAsignaturasAgregadas(
        lmpiarUndefined
      );
    }
  }, [
    gruposHabilitados,
    listadoAsignaturasEstudiante,
  ]);

  // =========================================================
  // SESIONES
  // =========================================================
  function sumarDiasFinFullCalendar(
    fecha,
    dias
  ) {
    let dataFinal = new Date(fecha).setDate(
      new Date(fecha).getDate() + dias
    );

    return dataFinal;
  }

  useEffect(() => {
    let dataEventos = [];

    if (gruposHabilitados.length > 0) {
      let dataTotal =
        gruposHabilitados.filter(
          (listado) => {
            if (listado.basignado == true) {
              return listado;
            }
          }
        );

      dataTotal.map((listado) => {
        let data2 =
          listado.dhorario.split(",");

        let splitHorariosResult = [];

        splitHorariosResult = [
          ...splitHorariosResult,
          ...data2,
        ];
      });

      const pushEventos = (data) => {
        let dataEventos = [];

        data.forEach((listado) => {
          let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;

          let descritions = `<ul>
            <li>Equivalente:
              <strong>${listado.dequivalente}</strong>
            </li>
            <li>Grupo:
              <strong>${listado.sgrupo}</strong>
            </li>
            <li>Modalidad:
              <strong>${listado.dmodalidad}</strong>
            </li>
            <li>Horario:
              <strong>${listado.dhorario}</strong>
            </li>
            <li>Inicio:
              <strong>${formatterDate(listado.finicio)}</strong>
            </li>
            <li>Fin:
              <strong>${formatterDate(listado.ffin)}</strong>
            </li>
            <li>Docente:
              <strong>${listado.ddocente}</strong>
            </li>
            <li>Créditos:
              <strong>${listado.ncredito}</strong>
            </li>
          </ul>`;

          let evento;

          if (listado.nhoras > 0) {
            evento = {
              id: codigoUnico,
              title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
              description: descritions,
              start: listado.hinicio,
              end: listado.hfinal,
            };
          } else {
            evento = {
              id: codigoUnico,
              title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
              description: descritions,
              start: listado.finicio,
              end: listado.ffin,
              allDay: true,
            };
          }

          dataEventos.push(evento);
        });
      };

      const listSesiones = async () => {
        try {
          setLoading(true);

          await sesionesHabilitadas(
            obtenerDatosEstudiante
          );
        } catch (error) {
          console.error(
            "Error obteniendo sesiones:",
            error
          );
        } finally {
          setLoading(false);
        }
      };
    }

    if (pasoProcesoM === 3) {
      setPasoSegundaVistaProcesoM(false);
    }
  }, [gruposHabilitados]);

  // =========================================================
  // FILTRAR DIA
  // =========================================================
  let filtrarDia = (dia) => {
    switch (dia) {
      case "Lu":
        return 1;

      case "Ma":
        return 2;

      case "Mi":
        return 3;

      case "Ju":
        return 4;

      case "Vi":
        return 5;

      case "Sá":
        return 6;

      default:
        return undefined;
    }
  };

  // =========================================================
  // CICLO I
  // =========================================================
  useEffect(() => {
    if (dciclo == "I") {
      let dataTotal =
        gruposHabilitados.map((data) => {
          if (data.basignado == true) {
            let inicio = formatterDate(
              data.finicio
            );

            let fin = formatterDate(
              data.ffin
            );

            const newRow = {
              scurso: data.scurso,
              sgrupo: data.sgrupo,
              dcurso: data.dcurso,
              gtipo: data.stipo,
              ncreditos: data.ncredito,
              nhoras: data.nhoras,
              dhorario: data.dhorario,
              finicio: inicio,
              ffin: fin,
              ddocente: data.ddocente,
              cciclo: data.cciclo,
              dsumilla: data.dsumilla,
              nveces: data.nveces,
              ccarrera: data.ccarrera,
              casignatura: data.casignatura,
              cgrupo: data.cgrupo,
              ctipo: data.dtipo,
              ccurso: data.ccurso,
              dequivalente:
                data.dequivalente,
              sequivalente:
                data.sequivalente,
              ccurso_origen:
                data.ccurso_origen,
              ccurso_equivalente:
                data.ccurso_equivalente,
              dmodalidad:
                data.dmodalidad,
              gmodalidad:
                data.gmodalidad,
            };

            return newRow;
          }

          return undefined;
        });

      setListAsignaturasAgregadas(
        dataTotal
      );
    }
  }, [gruposHabilitados]);

  // =========================================================
  // REDIRECCION AL INICIO
  // =========================================================
  useEffect(() => {
    if (!chequeoListo) return;

    /*
     * IMPORTANTE:
     *
     * Si venimos desde PagoFinish con:
     *
     * /matricula?autoStart=true
     *
     * NO debemos enviar al usuario a "/".
     *
     * Esto evita que vuelva al inicio.
     */
    if (autoStart === "true") {
      return;
    }

    const matriculaValida =
      fechaActual >= fechaInicio &&
      fechaActual <= fechaFin &&
      ckeckValidator;

    if (!matriculaValida) {
      navigate("/");
    }
  }, [
    chequeoListo,
    ckeckValidator,
    autoStart,
    fechaActual,
    fechaInicio,
    fechaFin,
    navigate,
  ]);

  // =========================================================
  // VALIDACION PARA MOSTRAR EL CONTENIDO
  // =========================================================

  /*
   * IMPORTANTE:
   *
   * Antes tenías:
   *
   * fechaActual >= fechaInicio &&
   * fechaActual <= fechaFin &&
   * ckeckValidator
   *
   * Si alguna de esas condiciones fallaba,
   * React no mostraba NADA.
   *
   * Ahora, cuando viene autoStart=true,
   * permitimos mostrar el proceso.
   */
  const puedeMostrarMatricula =
  autoStart === "true" ||
  (
    fechaActual >= fechaInicio &&
    fechaActual <= fechaFin &&
    ckeckValidator
  );


  // =========================================================
  // RENDER
  // =========================================================
  return (
    <>
      {!obtenerDatosEstudiante ? (
        <div className="text-center py-5">
          Cargando...
        </div>
      ) : puedeMostrarMatricula ? (
        <div className="steps-form">

          <div className="col-12 mb-4 two">
            <ProcesoMatricula />
          </div>

          {/* PASO 1 */}
          {validateUseProcesoMatri(1) && (
            <ActualizacionDeDatos />
          )}

          {/* PASO 2 */}
          {validateUseProcesoMatri(2) && (
            <ReglamentosDeEstudios />
          )}

          {/* PASO 3 - SEGURO */}
          {validateUseProcesoMatri(3) && (
            <Seguro />
          )}

          {/* PASO 4 - HORARIO */}
          {validateUseProcesoMatri(4) &&
            (
              dciclo !== "I"
                ? pasoSegundaVistaProcesoM === false
                : !dciclo === "I"
            ) && (
              <Horario />
            )}

          {/* PASO 4 - SELECCION HORARIO */}
          {validateUseProcesoMatri(4) &&
            (
              dciclo === "I"
                ? dciclo === "I"
                : pasoSegundaVistaProcesoM
            ) && (
              <SeleccionHorario />
            )}

          {/* PASO 5 - PAGO RESUMEN */}
          {validateUseProcesoMatri(5) &&
            pasoSegundaVistaProcesoM === false && (
              <PagoResumen />
            )}

          {/* PASO 5 - PAGO PENSIONES */}
          {validateUseProcesoMatri(5) &&
            pasoSegundaVistaProcesoM && (
              <PagoPensiones />
            )}

          {/* PASO 6 - CONFIRMACION PENDIENTE */}
          {validateUseProcesoMatri(6) &&
            pasoSegundaVistaProcesoM === false && (
              <ConfirmacionPendiente />
            )}

          {/* PASO 6 - CONFIRMACION */}
          {validateUseProcesoMatri(6) &&
            pasoSegundaVistaProcesoM && (
              <Confirmacion />
            )}

          <ModalError />
        </div>
      ) : null}
    </>
  );
};

export default Matricula;
